import { TrendingDown, TrendingUp, Flame, HeartHandshake, Zap, Users, Sparkles } from "lucide-react";

const items = [
  { icon: TrendingDown, label: "Rotación", dir: "down" },
  { icon: Flame, label: "Burnout", dir: "down" },
  { icon: TrendingDown, label: "Bajas", dir: "down" },
  { icon: Zap, label: "Productividad", dir: "up" },
  { icon: HeartHandshake, label: "Engagement", dir: "up" },
  { icon: Users, label: "Retención", dir: "up" },
  { icon: Sparkles, label: "Clima laboral", dir: "up" },
];

export function CompanyBenefits() {
  return (
    <section id="beneficios" className="relative py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-3xl text-center">
          <h2 className="text-3xl font-semibold tracking-tight text-foreground sm:text-4xl lg:text-5xl">
            Cuando las personas están mejor, <br className="hidden sm:block" />
            <span className="text-gradient-brand">el negocio también.</span>
          </h2>
        </div>

        <div className="mt-16 grid grid-cols-2 gap-4 md:grid-cols-4 lg:grid-cols-7">
          {items.map((it) => (
            <div key={it.label} className="group rounded-3xl border border-border bg-card p-5 text-center shadow-soft transition hover:-translate-y-1">
              <div className="mx-auto flex h-11 w-11 items-center justify-center rounded-2xl gradient-soft">
                <it.icon className={`h-5 w-5 ${it.dir === "up" ? "text-primary" : "text-secondary"}`} strokeWidth={2} />
              </div>
              <p className="mt-3 text-xs font-medium uppercase tracking-wider text-muted-foreground">
                {it.dir === "up" ? "↑" : "↓"}
              </p>
              <p className="text-sm font-semibold text-foreground">{it.label}</p>
            </div>
          ))}
        </div>

        <p className="mx-auto mt-14 max-w-2xl text-center text-lg text-muted-foreground">
          Detectar el desgaste <span className="text-foreground font-medium">antes de que se convierta en una crisis.</span>
        </p>
      </div>
    </section>
  );
}
